import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';

export const EditorialLink = ({ to, children, testId, button = false, className = '', ...props }) => {
  const external = /^https?:/.test(to);
  const Component = external ? 'a' : Link;
  return <Component {...(external ? { href: to, target: '_blank', rel: 'noopener' } : { to })} className={`${button ? 'tlb-button' : 'tlb-text-link'} ${className}`} data-testid={testId} {...props}>{children}{external ? <ArrowUpRight aria-hidden="true" /> : <ArrowRight aria-hidden="true" />}</Component>;
};